/**
 * THE rename file.
 *
 * The only file in the repo allowed to contain trademarked names
 * (enforced by tools/check-ip-strings.mjs). Every player-visible name,
 * lore string, and brand mark is templated over this object, and saves
 * store lexicon keys rather than display strings — so a full rebrand is
 * an edit to this file and nothing else.
 */
export const IP = {
  GAME_TITLE: 'Songlets',
  STUDIO: 'Songsoft',
  CREATURE: 'Songlet',
  CREATURES: 'Songlets',
  COLLECTIVE: 'the Song',
  TAGLINE: 'They only grow.',
} as const;

export type IpKey = keyof typeof IP;
